module.exports = __webpack_public_path__ + "img/logo.47b5ee4b.png";